import { api } from '../main-api/apiClient';

// Clinic Management APIs
export const clinicAPI = {
  // Get all clinics
  getAllClinics: (skip = 0, limit = 100) => 
    api.get('/admin/clinics', { params: { skip, limit } }),

  // Get clinic details
  getClinicDetails: (clinicId) => 
    api.get(`/admin/clinics/${clinicId}`),

  // Create new clinic
  createClinic: (clinicData) => {
    const formData = new FormData();
    Object.keys(clinicData).forEach(key => {
      if (clinicData[key] !== null && clinicData[key] !== undefined) {
        formData.append(key, clinicData[key]);
      }
    });
    return api.post('/admin/clinics', formData);
  },

  // Update clinic
  updateClinic: (clinicId, clinicData) => {
    const formData = new FormData();
    Object.keys(clinicData).forEach(key => {
      if (clinicData[key] !== null && clinicData[key] !== undefined) {
        formData.append(key, clinicData[key]);
      }
    });
    return api.put(`/admin/clinics/${clinicId}`, formData);
  },

  // Delete clinic
  deleteClinic: (clinicId) => 
    api.delete(`/admin/clinics/${clinicId}`),

  // Get clinic users
  getClinicUsers: (clinicId, skip = 0, limit = 100) => 
    api.get(`/admin/clinics/${clinicId}/users`, { params: { skip, limit } }),

  // Get system statistics
  getSystemStatistics: () => 
    api.get('/admin/system/statistics')
};

// User Management APIs
export const userAPI = {
  // Get all users with filtering
  getAllUsers: (params = {}) => {
    const { skip = 0, limit = 100, clinic_id, role, status, search } = params;
    return api.get('/admin/users', { 
      params: { skip, limit, clinic_id, role, status, search } 
    });
  },

  // Get user details
  getUserDetails: (userId) => 
    api.get(`/admin/users/${userId}`),

  // Create new user
  createUser: (userData) => {
    const formData = new FormData();
    Object.keys(userData).forEach(key => {
      if (userData[key] !== null && userData[key] !== undefined) {
        formData.append(key, userData[key]);
      }
    });
    return api.post('/admin/users', formData);
  },

  // Update user
  updateUser: (userId, userData) => {
    const formData = new FormData();
    Object.keys(userData).forEach(key => {
      if (userData[key] !== null && userData[key] !== undefined) {
        formData.append(key, userData[key]);
      }
    });
    return api.put(`/admin/users/${userId}`, formData);
  },

  // Delete user
  deleteUser: (userId) => 
    api.delete(`/admin/users/${userId}`),

  // Transfer user to different clinic
  transferUser: (userId, newTenantId) => {
    const formData = new FormData();
    formData.append('new_tenant_id', newTenantId);
    return api.post(`/admin/users/${userId}/transfer`, formData);
  },

  // Bulk update users
  bulkUpdateUsers: (userIds, updateData) => {
    const formData = new FormData();
    formData.append('user_ids', userIds.join(','));
    Object.keys(updateData).forEach(key => {
      if (updateData[key] !== null && updateData[key] !== undefined) {
        formData.append(key, updateData[key]);
      }
    });
    return api.post('/admin/users/bulk', formData);
  }
};

export default {
  clinics: clinicAPI,
  users: userAPI
};